import styled from 'styled-components';
import { dfdDefaultTheme } from 'theme/material-ui';

export const IconText = styled.span`
  padding: 6px;
  ${dfdDefaultTheme.breakpoints.down('md')} {
    display: none;
  }
`;
